export const TEST_ID = 'equipmentTabs';
